import { render, staticRenderFns } from "./TeamContainer.vue?vue&type=template&id=2f1b4018&scoped=true&"
import script from "./TeamContainer.vue?vue&type=script&lang=js&"
export * from "./TeamContainer.vue?vue&type=script&lang=js&"
import style0 from "./TeamContainer.vue?vue&type=style&index=0&id=2f1b4018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b4018",
  null
  
)

export default component.exports